export default __webpack_public_path__ + "static/media/logo-sm.ce23d2c4.svg";